// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__3EM3U","requisite":"styles_requisite__3kzM0"};